/**
 * Created by codingnuts on 2017/12/19.
 */
import axios from 'axios';
import readProd from "@project/config/index.js";
import ValidateRules from "./utils/ValidateRules";
import vv from "./utils/vv";
import DrawImage from "./utils/DrawImage";
import CreateCode from "./utils/CreateCode";
import CookieUtils from "./utils/CookieUtils";
import {
  FIELD_ADAPTER
} from "./utils/FieldAdapter";
import toOtherPage from "./utils/ToOtherPage";
import readUtils from "./utils/toRead";
import mobileLoading from "./utils/MobileLoading";
import i18n from "./utils/i18n"
import des from "./utils/des"
import JsEncrypt from "./utils/JsEncrypt"

try {
  if (typeof $_$.IS_DISABLE != "undefined" && $_$.IS_DISABLE) { // 站点被禁用
    var targetUrl = "../pages/disablepage.html";
    if (window.location.href.indexOf('disablepage.html') === -1) { // 不在重定向页面
      window.location.href = targetUrl;
    }
  }
} catch (error) {
  console.log(error);
}
var _axios = axios.create({
  timeout: 400000,
  withCredentials: true
});

var Token = function getToken() {
  let session = window.sessionStorage;
  let local = window.localStorage;

  let token = session.getItem('token');
  if (!token) {
    token = local.getItem('token');
    if (!token) {
      token = '';
    }
  }
  return token;
}

_axios.defaults.headers.token = Token();
// 添加自定义siteId到请求头
// let siteId = (CONFIG && CONFIG.SITE_CONFIG && CONFIG.SITE_CONFIG.siteId) || "";
// _axios.defaults.headers.siteId = siteId;

var cookie = CookieUtils.getCookie('token')
if (cookie || CONFIG && CONFIG.COOKIE) { //新增依赖cookie登录与退出
  _axios.defaults.headers.token = cookie
}
let sid = window.location.href.split('/')[3]
if(sid.indexOf('pub-')!=-1){
  sid = sid.replace('pub-','')
}else{
  sid = localStorage.getItem('sld')
}
_axios.defaults.headers.domain = sid;
// this.siteId = CONFIG.SITE_CONFIG.siteId;
// 添加请求拦截器
_axios.interceptors.request.use(function (config) {
  // console.log(config);
  // 在发送请求之前做些什么
  if (config.method == 'get') {
    if (config.params) {
      /* axios get params方式传参 中文已进行编码 */
      /* for (const key in config.params) {
        if (config.params.hasOwnProperty(key)) {
          // config.params[key] = encodeURI(config.params[key]);
        }
      } */
      config.params.v_stamp = new Date().getTime();
    } else {
      config.params = {
        v_stamp: new Date().getTime()
      }
    }
    config.url = encodeURI(config.url)
  }
  return config;
}, function (error) {
  // 对请求错误做些什么
  return Promise.reject(error);
});


var Get = _axios.get;
var Post = readProd || (process.env.NODE_ENV === 'production') ? _axios.post : _axios.get;
var Delete = _axios.delete;

var getFieldAdapter = (firstAdapter, secondAdapter) => {
  /* console.log(Object.assign(FIELD_ADAPTER[firstAdapter].systemAdapter, FIELD_ADAPTER[firstAdapter][secondAdapter])); */
  return Object.assign({}, FIELD_ADAPTER[firstAdapter].systemAdapter, FIELD_ADAPTER[firstAdapter][secondAdapter]);
}

window.addEventListener('storage', function (e) {
  if (e.key == 'token') {
    _axios.defaults.headers.token = Token();
  }
})

export {
  Get,
  Post,
  Delete,
  DrawImage,
  ValidateRules,
  CreateCode,
  vv,
  CookieUtils,
  _axios,
  Token,
  toOtherPage,
  getFieldAdapter,
  mobileLoading,
  i18n,
  readUtils,
  des,
  JsEncrypt
};



/* window.addEventListener('storage', function (e) {
  if (e.key == 'token') {
    window.location.reload();
  }
}) */



// WEBPACK FOOTER //
// ./src/components/common/index.js